import React from "react";

function MtnLogo() {
    return (
        <div className="mtn-logo pt-5">
            <svg width="64" height="42" viewBox="0 0 64 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.4978 2.33334L1.42221 40.8333H62.5778L52.6362 20.0736L47.6655 24.2255L35.9164 8.37256L27.7824 20.0736L19.4978 2.33334Z" fill="#488E27" stroke="#615D5D" strokeOpacity="0.87" />
            </svg>

        </div>
    )
}

export default MtnLogo;